var _templateObject, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import styled from '@emotion/styled';
import MUISvgIcon, { svgIconClasses } from '@mui/material/SvgIcon';
import * as React from "react";
var SvgIcon = styled(MUISvgIcon)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &.", " {\n    width: ", ";\n    height: ", ";\n    color: ", ";\n    stroke-width: 1px;\n    vector-effect: non-scaling-stroke;\n  }\n"])), svgIconClasses.root, function (_ref) {
  var size = _ref.size,
    theme = _ref.theme;
  return size && theme.size[size];
}, function (_ref2) {
  var size = _ref2.size,
    theme = _ref2.theme;
  return size && theme.size[size];
}, function (_ref3) {
  var color = _ref3.color,
    theme = _ref3.theme;
  return color && theme.color[color];
});
var SvgImagine = function SvgImagine(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#imagine_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d37047",
    stroke: "currentColor",
    d: "M11.786.5h8.625a3.25 3.25 0 0 1 2.298.952l15.839 15.839c.61.61.952 1.436.952 2.298v8.625c0 1.772-1.533 3.248-3.342 4.161a8.57 8.57 0 0 0-3.783 3.783c-.913 1.809-2.389 3.342-4.161 3.342h-8.625a3.25 3.25 0 0 1-2.298-.952L1.452 22.709A3.25 3.25 0 0 1 .5 20.411v-8.625c0-1.772 1.533-3.248 3.342-4.161a8.57 8.57 0 0 0 3.783-3.783C8.538 2.033 10.014.5 11.786.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebe5d2",
    d: "M24.64 30.177a1.74 1.74 0 0 1 1.98 1.076l-.713.273a.973.973 0 1 0 .032.6l.738.199a1.736 1.736 0 1 1-2.038-2.148"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebe5d2",
    fillRule: "evenodd",
    d: "M25 28.75A3.125 3.125 0 1 1 25 35a3.125 3.125 0 0 1 0-6.25m0 .688a2.437 2.437 0 1 0 0 4.874 2.437 2.437 0 0 0 0-4.874",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebe5d2",
    d: "M15.625 7.375a7 7 0 0 0 7 7H25v1.25h-2.375a7 7 0 0 0-7 7V25h-1.25v-2.375a7 7 0 0 0-7-7H5v-1.25h2.375a7 7 0 0 0 7-7V5h1.25z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "imagine_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  }))))));
};
export default SvgImagine;